document.addEventListener("DOMContentLoaded", () => {
  const open360model = () => {
    // Instead of using a selector, define the gallery elements
    const myGallery = GLightbox({
      touchNavigation: true,
      height: "90vh",
      elements: [
        {
          type: "external",
          href: "https://storage.googleapis.com/insujet/3dmodel_injector.html", //"/pages/inusujet-3d-model?shpxid=6cdc4466-9c4b-4851-9470-3f17e5c9f476h",
        },
      ],
    });
    myGallery.open();
  };

  document.querySelectorAll('a[href*="#injector-360-model"]').forEach((e) => {
    e.addEventListener("click", (clickEvent) => {
      console.log("Open");
      open360model();
      return false;
    });
  });
});
